import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Attendance } from './attendance';
export { Attendance };
import { attendanceSchema } from '@schemas/business-objects/attendance';
import { SessionFormArray } from './session-form-group';
import { StudentFormGroup } from './student-form-group';
import { TermTimeFormGroup } from './term-time-form-group';
import { TermTutorFormGroup } from './term-tutor-form-group';

export class AttendanceFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    date: SchemaFormControl;
    attendanceType: SchemaFormControl;
    absenceType: SchemaFormControl;
    isTemporaryAssignment: SchemaFormControl;
    studentId: SchemaFormControl;
    student: StudentFormGroup;
    termTutorId: SchemaFormControl;
    termTutor: TermTutorFormGroup;
    timeId: SchemaFormControl;
    time: TermTimeFormGroup;
    sessions: SessionFormArray;
  };

  declare value: Partial<Attendance>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(attendanceSchema, Attendance, data, options);
  }

  get object(): Attendance {
    return new Attendance(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'student':
        return new StudentFormGroup();
      case 'termTutor':
        return new TermTutorFormGroup();
      case 'time':
        return new TermTimeFormGroup();
      case 'sessions':
        return new SessionFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Attendance[]> {
    return Attendance.find(filter);
  }

  static async findOne(filter?: any): Promise<Attendance | null> {
    return Attendance.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Attendance> {
    return Attendance.findById(id, filter);
  }

  static async create(data: Partial<Attendance>): Promise<Attendance> {
    return Attendance.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<Attendance>,
  ): Promise<Attendance> {
    return Attendance.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Attendance.deleteById(id);
  }
}

export class AttendanceFormArray extends PersistedFormArray {
  readonly entityName = 'Attendance' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(attendanceSchema, Attendance, options);
  }

  protected override createItemGroup() {
    return new AttendanceFormGroup();
  }

  get array(): Attendance[] {
    return this.controls.map((group: AttendanceFormGroup) => group.object);
  }
}

export class AttendancePersistedArray extends PersistedArray<Attendance> {
  readonly entityName = 'Attendance' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Attendance, options);
  }
}
